import React, { Component } from 'react';
import {CurrencyContext} from '@checkout-c/CurrencyContext';
import { getJSFormattedCurrency } from '@checkout-h/currency';

class FormattedCurrency extends Component {
    render() {
        return(
            <CurrencyContext.Consumer>
                {config => {
                    return (
                        <span className="formatted-currency">{getJSFormattedCurrency(this.props.children, config)}</span>
                    )
                }}
            </CurrencyContext.Consumer>
        )
    }
}

export default FormattedCurrency;
